import { render } from "./ServiceSetting.vue?vue&type=template&id=4c961ef0"
import script from "./ServiceSetting.vue?vue&type=script&lang=js"
export * from "./ServiceSetting.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__